if (!customElements.get('dut-card-gallery')) {
  customElements.define('dut-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.images = JSON.parse(this.querySelector('script').textContent);
      this.index = 0;
      this.addEventListener('click', async event => {
        const button = event.target.closest('button');
        if (!button) return;
        event.preventDefault(); event.stopPropagation();
        if (this.busy) return;
        const next = button.dataset.imageIndex !== undefined ? Number(button.dataset.imageIndex) : this.index + (button.classList.contains('dut-card-gallery__prev') ? -1 : 1);
        const index = (next + this.images.length) % this.images.length;
        if (index === this.index) return;
        this.busy = true;
        let overlay;
        try {
          const source = this.images[index];
          const preload = new Image();
          preload.src = source.src;
          await preload.decode();
          if (!this.isConnected) return;
          const image = this.parentElement.querySelector('.card__media img');
          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!reducedMotion) {
            overlay = image.cloneNode();
            overlay.removeAttribute('id');
            overlay.className = 'dut-gallery-outgoing';
            overlay.alt = '';
            overlay.setAttribute('aria-hidden', 'true');
            image.parentElement.append(overlay);
          }
          image.removeAttribute('srcset');
          image.src = source.src;
          image.alt = source.alt;
          this.index = index;
          this.querySelectorAll('[data-image-index]').forEach(dot => {
            if (Number(dot.dataset.imageIndex) === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (overlay) await overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 320, easing: 'ease-in-out', fill: 'forwards' }).finished;
        } catch {
          // Keep the current image if the next image cannot be loaded.
        } finally {
          overlay?.remove();
          this.busy = false;
        }
      });
    }
  });
}
function updateFilterOffset() {
  const bars = [...document.querySelectorAll('.essential_annoucement_bar_wrapper')];
  const bottom = bars.reduce((value, bar) => {
    const rect = bar.getBoundingClientRect();
    return rect.top <= 1 && rect.bottom > 0 ? Math.max(value, rect.bottom) : value;
  }, 0);
  document.documentElement.style.setProperty('--dut-filter-top', `${bottom}px`);
}
document.addEventListener('toggle', event => {
  if (event.target.matches('.mobile-facets__disclosure')) updateFilterOffset();
}, true);
window.addEventListener('resize', updateFilterOffset);
updateFilterOffset();

if (!customElements.get('dut-sort-picker')) {
  customElements.define('dut-sort-picker', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select || this.querySelector('.dut-sort-trigger')) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.trigger = document.createElement('button');
      this.trigger.type = 'button';
      this.trigger.className = 'dut-sort-trigger';
      this.trigger.setAttribute('aria-haspopup', 'menu');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.menu = document.createElement('div');
      this.menu.className = 'dut-sort-menu';
      this.menu.setAttribute('role', 'menu');
      this.menu.setAttribute('aria-label', 'Sort products');
      this.menu.hidden = true;
      this.select.tabIndex = -1;
      this.select.setAttribute('aria-hidden', 'true');
      this.classList.add('dut-sort-enhanced');
      for (const option of this.select.options) {
        if (option.hidden) continue;
        const item = document.createElement('button');
        item.type = 'button';
        item.setAttribute('role', 'menuitemradio');
        item.dataset.value = option.value;
        item.textContent = option.textContent.trim();
        item.addEventListener('click', () => {
          this.select.value = option.value;
          this.sync();
          this.close(true);
          this.select.dispatchEvent(new Event('input', { bubbles: true }));
        });
        this.menu.append(item);
      }
      this.append(this.trigger, this.menu);
      this.sync();
      this.trigger.addEventListener('click', () => {
        if (!this.menu.hidden) return this.close();
        this.open();
        this.menu.querySelector('[aria-checked="true"]')?.focus();
      });
      this.addEventListener('keydown', event => {
        const items = [...this.menu.querySelectorAll('button')];
        if (event.key === 'Escape') {
          event.preventDefault(); this.close(true);
        } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          this.open();
          let index = items.indexOf(document.activeElement);
          index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
          items[index]?.focus();
        }
      });
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, { signal });
      window.addEventListener('scroll', () => {
        if (!this.menu.hidden) this.close();
      }, { signal, passive: true });
      window.addEventListener('resize', () => {
        if (!this.menu.hidden) this.close();
      }, { signal, passive: true });
      this.addEventListener('focusout', () => {
        setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0);
      }, { signal });
    }
    sync() {
      const label = this.select.selectedOptions[0]?.textContent.trim() || 'Sort by';
      this.trigger.textContent = label;
      this.trigger.setAttribute('aria-label', 'Sort products: ' + label);
      for (const item of this.menu.querySelectorAll('[data-value]')) item.setAttribute('aria-checked', String(item.dataset.value === this.select.value));

    }
    open() {
      this.menu.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      const rect = this.trigger.getBoundingClientRect();
      const viewport = window.visualViewport?.height || innerHeight;
      const headerBottom = Math.max(0, document.querySelector('sticky-header')?.getBoundingClientRect().bottom || 0);
      const below = viewport - rect.bottom - 16;
      const above = rect.top - headerBottom - 16;
      const flip = below < 380 && above > below;
      this.menu.style.top = flip ? 'auto' : 'calc(100% + 8px)';
      this.menu.style.bottom = flip ? 'calc(100% + 8px)' : 'auto';
      this.menu.style.maxHeight = `${Math.max(120, Math.min(420, flip ? above : below))}px`;
    }
    close(focus = false) {
      this.menu.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      if (focus) this.trigger.focus();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
